import { EmailBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';

export const Email: React.FC = () => {
    const email = usePaymentStore((s) => s.email);
    const set_email = usePaymentStore((s) => s.set_email);

    return (
        <EmailBox
            value={email}
            onChange={(value) => set_email(value)}
            label='Email'
            required={true}
        />
    );
};
